import React from "react";

// Wordmark lockup — editorial serif with tracking
export const Wordmark = ({ className = "", size = "md", color = "#3B0B0B" }) => {
  const sizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-3xl",
    xl: "text-5xl",
  };
  return (
    <span
      className={`font-serif ${sizes[size]} tracking-[0.24em] leading-none select-none ${className}`}
      style={{ color }}
      data-testid="fyllr-wordmark"
    >
      FYLLR
    </span>
  );
};

// Monogram F — large editorial serif with a fine hairline beneath
export const Monogram = ({ size = 96, color = "#3B0B0B", bg = "#F6F0E8", className = "" }) => (
  <div
    className={`inline-flex items-center justify-center ${className}`}
    style={{
      width: size,
      height: size,
      background: bg,
      borderRadius: `${size * 0.22}px`,
      boxShadow: "inset 0 0 0 1px rgba(58,43,34,0.14)",
    }}
    data-testid="fyllr-monogram"
  >
    <svg viewBox="0 0 100 100" width={size * 0.7} height={size * 0.7} aria-hidden="true">
      <text
        x="50"
        y="74"
        textAnchor="middle"
        fontFamily="'Instrument Serif', serif"
        fontSize="86"
        fill={color}
        fontStyle="italic"
      >
        F
      </text>
      <line x1="18" y1="86" x2="82" y2="86" stroke={color} strokeWidth="1" />
    </svg>
  </div>
);

export default Wordmark;
